// CRM 목업 데이터 - 농산물 박스 제조업

import type { Lead, Opportunity, Customer, Activity } from '../types';

// 리드 데이터 - 농산물 관련 잠재고객
export const leads: Lead[] = [
  {
    id: 'LEAD001',
    code: 'LD-2025-001',
    name: '김농장',
    company: '충주사과영농조합',
    email: 'kim@chungju-apple.co.kr',
    phone: '010-1234-5678',
    status: 'new',
    source: 'trade_show',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    expectedRevenue: 45000000,
    description: '농업박람회에서 만남, 사과박스 연간 계약 검토 중',
    nextContactDate: '2025-01-30',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
  {
    id: 'LEAD002',
    code: 'LD-2025-002',
    name: '이대표',
    company: '서귀포감귤농협',
    email: 'lee@seogwipo-citrus.or.kr',
    phone: '010-2345-6789',
    status: 'contacted',
    source: 'referral',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    expectedRevenue: 120000000,
    description: '제주감귤농협 소개로 연락, 대량 감귤박스 공급 논의',
    nextContactDate: '2025-01-28',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-26',
  },
  {
    id: 'LEAD003',
    code: 'LD-2025-003',
    name: '박조합장',
    company: '논산딸기영농조합',
    email: 'park@nonsan-strawberry.co.kr',
    phone: '010-3456-7890',
    status: 'qualified',
    source: 'cold_call',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    expectedRevenue: 85000000,
    description: '딸기 시즌 대비 프리미엄 딸기박스 개발 요청',
    nextContactDate: '2025-02-01',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-27',
  },
  {
    id: 'LEAD004',
    code: 'LD-2025-004',
    name: '정사장',
    company: '가락시장농산물유통',
    email: 'jung@garak-agri.com',
    phone: '010-4567-8901',
    status: 'converted',
    source: 'website',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    expectedRevenue: 65000000,
    description: '웹사이트에서 채소박스 대량 주문 문의, 계약 완료',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-24',
  },
  {
    id: 'LEAD005',
    code: 'LD-2025-005',
    name: '최팀장',
    company: '청도반시작목반',
    email: 'choi@cheongdo-persimmon.kr',
    phone: '010-5678-9012',
    status: 'lost',
    source: 'advertisement',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    expectedRevenue: 35000000,
    description: '감박스 견적 비교 중 타사 선정',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-20',
  },
  {
    id: 'LEAD006',
    code: 'LD-2025-006',
    name: '한과장',
    company: '나주배작목반',
    email: 'han@naju-pear.co.kr',
    phone: '010-6789-0123',
    status: 'new',
    source: 'referral',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    expectedRevenue: 75000000,
    description: '나주배 명절 선물세트 박스 개발 문의',
    nextContactDate: '2025-01-29',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
];

// 영업기회 데이터 - 농산물 박스 프로젝트
export const opportunities: Opportunity[] = [
  {
    id: 'OPP001',
    code: 'OP-2025-001',
    name: '충주사과영농조합 연간 계약',
    customerId: 'CUST001',
    customerName: '충주사과영농조합',
    status: 'open',
    stage: 'qualification',
    probability: 25,
    expectedAmount: 45000000,
    expectedCloseDate: '2025-03-15',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    source: 'trade_show',
    description: '사과박스 5kg/10kg 연간 공급 계약 (예상 50,000박스)',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-27',
  },
  {
    id: 'OPP002',
    code: 'OP-2025-002',
    name: '서귀포감귤농협 대량 공급',
    customerId: 'CUST002',
    customerName: '서귀포감귤농협',
    status: 'quotation',
    stage: 'proposal',
    probability: 50,
    expectedAmount: 120000000,
    expectedCloseDate: '2025-02-28',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    source: 'referral',
    description: '감귤박스 10kg/20kg 및 선물세트 박스 연간 공급',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-26',
  },
  {
    id: 'OPP003',
    code: 'OP-2025-003',
    name: '논산딸기영농조합 프리미엄 박스',
    customerId: 'CUST003',
    customerName: '논산딸기영농조합',
    status: 'negotiation',
    stage: 'negotiation',
    probability: 75,
    expectedAmount: 85000000,
    expectedCloseDate: '2025-02-15',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    source: 'cold_call',
    description: '프리미엄 딸기박스 신규 디자인 개발 및 공급',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-27',
  },
  {
    id: 'OPP004',
    code: 'OP-2025-004',
    name: '가락시장농산물유통 채소박스',
    customerId: 'CUST004',
    customerName: '가락시장농산물유통',
    status: 'won',
    stage: 'closed_won',
    probability: 100,
    expectedAmount: 65000000,
    expectedCloseDate: '2025-01-24',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    source: 'website',
    description: '채소박스 5kg/10kg 정기 공급 계약 체결',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-24',
  },
  {
    id: 'OPP005',
    code: 'OP-2025-005',
    name: '청도반시작목반 감박스',
    customerId: 'CUST005',
    customerName: '청도반시작목반',
    status: 'lost',
    stage: 'closed_lost',
    probability: 0,
    expectedAmount: 35000000,
    expectedCloseDate: '2025-01-20',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    source: 'advertisement',
    description: '가격 경쟁에서 패배, 경쟁사 선정',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-20',
  },
];

// 고객 데이터 - 농산물 생산자 및 유통업체
export const customers: Customer[] = [
  {
    id: 'CUST001',
    code: 'C-001',
    name: '충주사과영농조합',
    type: 'company',
    email: 'contact@chungju-apple.co.kr',
    phone: '043-1234-5678',
    address: '충청북도 충주시 사과로 123',
    industry: '농업/과수',
    website: 'www.chungju-apple.co.kr',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    totalRevenue: 0,
    lastContactDate: '2025-01-27',
    isActive: true,
    createdAt: '2025-01-25',
    updatedAt: '2025-01-27',
  },
  {
    id: 'CUST002',
    code: 'C-002',
    name: '서귀포감귤농협',
    type: 'company',
    email: 'info@seogwipo-citrus.or.kr',
    phone: '064-2345-6789',
    address: '제주특별자치도 서귀포시 감귤로 456',
    industry: '농업/과수',
    website: 'www.seogwipo-citrus.or.kr',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    totalRevenue: 180000000,
    lastContactDate: '2025-01-26',
    isActive: true,
    createdAt: '2024-06-15',
    updatedAt: '2025-01-26',
  },
  {
    id: 'CUST003',
    code: 'C-003',
    name: '논산딸기영농조합',
    type: 'company',
    email: 'sales@nonsan-strawberry.co.kr',
    phone: '041-3456-7890',
    address: '충청남도 논산시 딸기로 789',
    industry: '농업/과수',
    website: 'www.nonsan-strawberry.co.kr',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    totalRevenue: 0,
    lastContactDate: '2025-01-27',
    isActive: true,
    createdAt: '2025-01-15',
    updatedAt: '2025-01-27',
  },
  {
    id: 'CUST004',
    code: 'C-004',
    name: '가락시장농산물유통',
    type: 'company',
    email: 'business@garak-agri.com',
    phone: '02-4567-8901',
    address: '서울시 송파구 가락동 321',
    industry: '농산물유통',
    website: 'www.garak-agri.com',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    totalRevenue: 65000000,
    lastContactDate: '2025-01-24',
    isActive: true,
    createdAt: '2025-01-10',
    updatedAt: '2025-01-24',
  },
  {
    id: 'CUST005',
    code: 'C-005',
    name: '청도반시작목반',
    type: 'company',
    email: 'contact@cheongdo-persimmon.kr',
    phone: '054-5678-9012',
    address: '경상북도 청도군 반시로 654',
    industry: '농업/과수',
    website: 'www.cheongdo-persimmon.kr',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    totalRevenue: 0,
    lastContactDate: '2025-01-20',
    isActive: false,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-20',
  },
];

// 활동 데이터 - 농산물 박스 영업 활동
export const activities: Activity[] = [
  {
    id: 'ACT001',
    type: 'call',
    subject: '박스 규격 상담 전화',
    description: '사과박스 5kg/10kg 규격 및 인쇄 디자인 상담',
    status: 'completed',
    relatedTo: 'lead',
    relatedId: 'LEAD001',
    relatedName: '김농장 (충주사과영농조합)',
    scheduledDate: '2025-01-25',
    completedDate: '2025-01-25',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    createdAt: '2025-01-25',
  },
  {
    id: 'ACT002',
    type: 'meeting',
    subject: '현장 방문 미팅',
    description: '감귤 포장 현장 방문, 박스 샘플 제시',
    status: 'planned',
    relatedTo: 'opportunity',
    relatedId: 'OPP002',
    relatedName: '서귀포감귤농협 대량 공급',
    scheduledDate: '2025-01-30',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    createdAt: '2025-01-26',
  },
  {
    id: 'ACT003',
    type: 'email',
    subject: '견적서 발송',
    description: '프리미엄 딸기박스 견적서 및 디자인 시안 발송',
    status: 'completed',
    relatedTo: 'opportunity',
    relatedId: 'OPP003',
    relatedName: '논산딸기영농조합 프리미엄 박스',
    scheduledDate: '2025-01-27',
    completedDate: '2025-01-27',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    createdAt: '2025-01-27',
  },
  {
    id: 'ACT004',
    type: 'task',
    subject: '샘플 박스 제작',
    description: '딸기박스 샘플 5종 제작 및 발송 준비',
    status: 'planned',
    relatedTo: 'opportunity',
    relatedId: 'OPP003',
    relatedName: '논산딸기영농조합 프리미엄 박스',
    scheduledDate: '2025-01-29',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    createdAt: '2025-01-27',
  },
  {
    id: 'ACT005',
    type: 'call',
    subject: '수요량 확인 전화',
    description: '감귤 시즌 예상 수요량 및 납품 일정 확인',
    status: 'planned',
    relatedTo: 'lead',
    relatedId: 'LEAD002',
    relatedName: '이대표 (서귀포감귤농협)',
    scheduledDate: '2025-01-28',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    createdAt: '2025-01-26',
  },
  {
    id: 'ACT006',
    type: 'note',
    subject: '고객 요구사항 정리',
    description: '나주배 선물세트 박스 디자인 요구사항 문서화 (고급 인쇄, 금박 로고)',
    status: 'completed',
    relatedTo: 'customer',
    relatedId: 'CUST003',
    relatedName: '논산딸기영농조합',
    completedDate: '2025-01-27',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    createdAt: '2025-01-27',
  },
];

// 유틸리티 함수
export const getLeadById = (id: string): Lead | undefined => {
  return leads.find((l) => l.id === id);
};

export const getOpportunityById = (id: string): Opportunity | undefined => {
  return opportunities.find((o) => o.id === id);
};

export const getCustomerById = (id: string): Customer | undefined => {
  return customers.find((c) => c.id === id);
};

// CRM 통계
export const getCRMStats = () => {
  const totalLeads = leads.length;
  const newLeads = leads.filter((l) => l.status === 'new').length;
  const convertedLeads = leads.filter((l) => l.status === 'converted').length;
  const conversionRate = totalLeads > 0 ? (convertedLeads / totalLeads) * 100 : 0;

  const totalOpportunities = opportunities.length;
  const openOpportunities = opportunities.filter((o) => o.status === 'open' || o.status === 'quotation' || o.status === 'negotiation').length;
  const wonOpportunities = opportunities.filter((o) => o.status === 'won').length;
  const lostOpportunities = opportunities.filter((o) => o.status === 'lost').length;
  const winRate = (wonOpportunities + lostOpportunities) > 0
    ? (wonOpportunities / (wonOpportunities + lostOpportunities)) * 100
    : 0;

  const pipelineValue = opportunities
    .filter((o) => o.status !== 'won' && o.status !== 'lost')
    .reduce((sum, o) => sum + o.expectedAmount * (o.probability / 100), 0);

  const totalRevenue = opportunities
    .filter((o) => o.status === 'won')
    .reduce((sum, o) => sum + o.expectedAmount, 0);

  const activeCustomers = customers.filter((c) => c.isActive).length;
  const totalCustomers = customers.length;

  const plannedActivities = activities.filter((a) => a.status === 'planned').length;
  const completedActivities = activities.filter((a) => a.status === 'completed').length;

  return {
    totalLeads,
    newLeads,
    conversionRate,
    totalOpportunities,
    openOpportunities,
    winRate,
    pipelineValue,
    totalRevenue,
    activeCustomers,
    totalCustomers,
    plannedActivities,
    completedActivities,
  };
};

// 리드 상태별 통계
export const getLeadStatusStats = () => {
  const stats: Record<string, number> = {};
  leads.forEach((lead) => {
    stats[lead.status] = (stats[lead.status] || 0) + 1;
  });
  return stats;
};

// 영업기회 단계별 통계
export const getOpportunityStageStats = () => {
  const stats: Record<string, { count: number; value: number }> = {};
  opportunities.forEach((opp) => {
    if (!stats[opp.stage]) {
      stats[opp.stage] = { count: 0, value: 0 };
    }
    stats[opp.stage].count += 1;
    stats[opp.stage].value += opp.expectedAmount;
  });
  return stats;
};

// 오늘의 활동
export const getTodayActivities = () => {
  const today = new Date().toISOString().split('T')[0];
  return activities.filter((a) => a.scheduledDate === today && a.status === 'planned');
};

// 예정된 활동
export const getUpcomingActivities = () => {
  const today = new Date().toISOString().split('T')[0];
  return activities
    .filter((a) => a.scheduledDate && a.scheduledDate >= today && a.status === 'planned')
    .sort((a, b) => (a.scheduledDate || '').localeCompare(b.scheduledDate || ''))
    .slice(0, 5);
};
